export const voices = [
	{ lang: 'Arabic', prefix: 'ar' },
	{ lang: 'English', prefix: 'en' },
	{ lang: 'French', prefix: 'fr' },
	{ lang: 'German', prefix: 'ge' },
];
